import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { ClassesStackParamList } from '@/types/navigation';
import MyClassesScreen from '@/screens/classes/MyClassesScreen';
import ClassDetailScreen from '@/screens/classes/ClassDetailScreen';
import StaffMemberScreen from '@/screens/classes/StaffMemberScreen';
import { colors, font } from '@/theme/chalkCourt';

const Stack = createStackNavigator<ClassesStackParamList>();

/**
 * Classes tab: today's Now/Next class + all of the day's classes, a class's
 * rotations + roster, and (admins) the staff view and a staff member's day.
 */
const ClassesNavigator: React.FC = () => (
  <Stack.Navigator
    screenOptions={{
      headerStyle: { backgroundColor: colors.bg, shadowColor: 'transparent' },
      headerTintColor: colors.ink,
      headerTitleStyle: { fontFamily: font.displayBold, fontSize: 20 },
      headerBackTitleVisible: false,
      cardStyle: { backgroundColor: colors.bg },
    }}>
    <Stack.Screen name="ClassesHome" component={MyClassesScreen} options={{ headerShown: false }} />
    <Stack.Screen name="StaffMember" component={StaffMemberScreen} options={{ title: 'Staff Classes' }} />
    <Stack.Screen
      name="ClassDetail"
      component={ClassDetailScreen}
      options={({ route }) => ({ title: route.params.title })}
    />
  </Stack.Navigator>
);

export default ClassesNavigator;
